<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app temporary absolute>
      <v-list-item>
        <v-list-item-content v-if="user">
          <v-list-item-title class="user__title">{{ user }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />
      <v-list dense>
        <v-list-item
          @click="
            $router.push('/dashboard');
            drawer = false;
          "
        >
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $i18n.t('dashboard.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="
            $router.push('/parcels');
            drawer = false;
          "
        >
          <v-list-item-action>
            <v-icon>mdi-terrain</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $i18n.t('dashboard.parcels.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="
            $router.push('/statistics');
            drawer = false;
          "
        >
          <v-list-item-action>
            <v-icon>mdi-poll</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $i18n.t('statistics.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="
            $router.push('/settings');
            drawer = false;
          "
        >
          <v-list-item-action>
            <v-icon>mdi-settings-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $i18n.t('settings.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="
            $router.push({ name: 'help', params: { locale: $i18n.locale } });
            drawer = false;
          "
        >
          <v-list-item-action>
            <v-icon>mdi-help</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $i18n.t('help.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary">
      <v-app-bar-nav-icon dark v-if="showNav" @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 100px">
        <v-img :src="require('@/assets/logo_txtwhite_bgtransparent.png')" contain height="50" max-width="73" />
      </v-toolbar-title>
      <v-spacer />
      <v-btn text dark :disabled="$i18n.locale === 'en'" @click="changeLanguage('en')">
        <span>EN</span>
      </v-btn>
      <v-btn text dark :disabled="$i18n.locale === 'pl'" @click="changeLanguage('pl')">
        <span>PL</span>
      </v-btn>
      <template v-if="showNav">
        <v-btn text dark @click="logOut">
          <span>{{ $t('login.logout') }}</span>
        </v-btn>
        <user-avatar
          v-if="currentUser"
          :user-id="currentUser.id"
          :url="currentUser.image_path || null"
          is-current-user-avatar
          avatar-size="40"
          icon-size="28"
        />
      </template>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <Snackbar />
    <FilesUploadProgress class="ml-3 mb-5" />
  </v-app>
</template>

<script>
import FilesUploadProgress from '@/components/FilesUploadProgress.vue';
import Snackbar from '@/components/Snackbar.vue';
import UserAvatar from '@/components/settings/UserAvatar';

export default {
  name: 'App',
  components: {
    FilesUploadProgress,
    Snackbar,
    UserAvatar
  },
  data: () => ({
    drawer: false
  }),
  watch: {
    drawer() {
      if (window.map) {
        window.map.updateSize();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.$vuetify.lang.current = lang;
      this.$root.$emit('changedLanguage');
    },
    checkStatus(process) {
      const id = process.id;
      const title = process.title;
      const subtitle = process.subtitle;
      const interval = setInterval(() => {
        if (!this.$store.getters.getLogged) {
          clearInterval(interval);
        } else {
          this.$store.dispatch('getPPTX', id).then(r => {
            if (r.status === 202) {
              const enc = new TextDecoder('utf-8');
              const arr = new Uint8Array(r.data);
              const data = JSON.parse(enc.decode(arr));
              this.$root.$emit(
                'showSnackbar',
                this.pptxStatus(title, subtitle) + data.offers_processed + '/' + data.offers_total
              );
            } else if (r.status === 200) {
              const blob = new Blob([r.data]);
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', `${title} (${subtitle}).pptx`);
              link.click();
              clearInterval(interval);
            } else {
              clearInterval(interval);
              this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.table.pptxError'));
            }
          });
        }
      }, 10000);
    },
    logOut() {
      window.onbeforeunload = null;
      this.$root.$emit('changeIsEdited', false);
      this.$store.commit('logOut');
      this.$store.commit('setLogged', false);
      this.$router.push({ name: 'login' });
    },
    pptxStatus(title, subtitle) {
      const status = this.$i18n.t('dashboard.table.pptxStatus') + ` ${title} (${subtitle}).pptx: `;
      return status;
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    showNav() {
      return this.$route.name !== 'presentation' && this.$store.getters.getLogged;
    },
    user() {
      return this.$store.getters.getUser;
    },
    process() {
      return this.$store.getters.getProcess;
    }
  },
  mounted() {
    this.changeLanguage('pl');
  },
  async updated() {
    if (this.showNav && (!this.currentUser || Object.keys(this.currentUser) < 1)) {
      await this.$store.dispatch('getUsers');
      this.$root.$emit('refreshCurrentUserAvatar');
    }
  },
  watch: {
    process(nV) {
      this.checkStatus(nV);
    }
  }
};
</script>

<style lang="scss">

.v-application .headline {
  font-size: 1.7rem !important;
}

.headline {
  color: var(--v-primary-base) !important;
}

.v-btn, .v-tab {
  font-weight: 600 !important;
}

h1 {
  font-weight: 500 !important;
}

th {
  font-weight: 600 !important;
}

.user__title {
  overflow: hidden;
  text-overflow: unset !important;
  white-space: unset !important;
}
.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  background-color: rgba($primary-color, 0.1);
  margin: 5px 5px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba($primary-color, 0.3);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgba($primary-color, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgba($primary-color, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba($primary-color, 0.5);
}

// all tables
.v-data-table td,
.v-data-table th {
  padding: 0 0 0 8px !important;
  font-size: 0.9rem !important;
}
.checkbox__table {
  width: 32px;
}

.v-text-field__slot,
.v-select__slot {
  label {
    left: 0px !important;
  }
}
.theme--light.v-data-table thead tr:last-child th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
// colors
.btnOrange {
  background-color: rgb(228, 115, 54) !important;
}
.btnExcel {
  background-color: rgb(77, 163, 98) !important;
}
.btn--filter {
  background-color: rgb(245, 170, 89) !important;
}
.btn--green {
  background-color: var(--v-primary-base) !important;
}
.map .ol-control button {
  background-color: var(--v-primary-base) !important;
}
</style>
